import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CredentialsService } from './credentials.service';
import { ApiService } from 'src/services/api.service';
import { RegisterContext } from 'src/services/login-context.model';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/main/bootstrap/toast/ToastService';
import {SecureStorageService} from "ngx-secure-storage";




/**
 * Provides a base for authentication workflow.
 * The login/logout methods should be replaced with proper implementation.
 */

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    getUserProfile(currentUser: any): any {
      throw new Error("Method not implemented.");
    }
    constructor(private apiService: ApiService, private credentialsService: CredentialsService,
      private storage:SecureStorageService,
      private router:Router, private toastService: ToastService ) {
        this.apiService.suppressAlertError = true;
    }

    getLoginPage() {
        return "/";
    }

    getGrantedAuthority(response:any){
      if (!!response){
        let authorities = response.authorities;
        return authorities.map(x => {return x.authority});
      }
      else{
        return [];
      }
    }

    checkPermission(response:any){
      let authorities = response.authorities;
      let grantedAuthority = authorities.filter(x => {
        return x.authority == "CAC_CRP_DATA_ENTRY_OFFICER"
        || x.authority == "CAC_CRP_ESCALATION_OFFICER_1"
        || x.authority == "CAC_CRP_ESCALATION_OFFICER_2"
        || x.authority == "CAC_CRP_DATA_ENTRY_RG"
      });
      // console.log(grantedAuthority)
      // console.log(grantedAuthority.length > 0)
      return (grantedAuthority.length > 0);
    }


    /**
     * Authenticates the user.
     * @param context The login parameters.
     * @return The user credentials.
     */
    login(context: any, remember: boolean): Observable<any> {
        return this.apiService.post_("/auth/login", JSON.stringify(context)).pipe(
            map((response: any) => {
              if (this.checkPermission(response)) {
                sessionStorage.setItem('PortalUserRole', JSON.stringify(this.getGrantedAuthority(response)));
                sessionStorage.setItem('accessToken', response.token);
                sessionStorage.setItem('currentUser', JSON.stringify(response.user));
                this.storage.store('encurrentUser', response.user, true)
                this.credentialsService.setCredentials(response, remember);
                return response;
              }
              else {
                // console.log(response);
                return false;
              }
            }),
            catchError(error => {
              this.router.navigate(['/login']);
            this.toastService.showDanger('Username or password incorrect!');

            // this.toastService.showDanger('Username or password incorrect!');
            // this.loading = false;
            // this.errorMessage = "Not Assign to Perform this Task!";
              // console.log('Catch')
                return of(error);
            })
        );
    }


  loginWithTOTP(request: any): Observable<any> {
    return this.apiService.post_("/auth/external/login", request)
    //   .pipe(
    //   map((response: any) => {
    //     // if (this.checkPermission(response)) {
    //     //   sessionStorage.setItem('PortalUserRole', JSON.stringify(this.getGrantedAuthority(response)));
    //     //   sessionStorage.setItem('accessToken', response.token);
    //     //   sessionStorage.setItem('currentUser', JSON.stringify(response.user));
    //     //   this.webStorage.setItem('encurrentUser',  JSON.stringify(response.user))
    //     //   // console.log(this.webStorage.getItem('encurrentUser'));
    //     //   this.credentialsService.setCredentials(response, true);
    //     //   return response;
    //     // }
    //     // else {
    //     //   // console.log(response);
    //     //   return false;
    //     // }
    //
    //     return response;
    //   }),
    //   catchError(error => {
    //     // this.router.navigate(['/login']);
    //     this.toastService.showDanger('Username or password incorrect!');
    //
    //     // this.toastService.showDanger('Username or password incorrect!');
    //     // this.loading = false;
    //     // this.errorMessage = "Not Assign to Perform this Task!";
    //     // console.log('Catch')
    //     return of(error);
    //   })
    // );
  }


  setupOtp(request: any): Observable<any> {
    return this.apiService.post_("/auth/external/totp/setup", request);
  }


  verifyOtp(request: any): Observable<any> {
    return this.apiService.post_(`/auth/external/totp/verify`, request).pipe(
      map((response: any) => {
        response['authorities'] = response?.data?.portalUser?.roles?.map(r => ({
          authority: r?.role || ""
        }));
        response["user"] = this.mapUserObject(response?.data?.portalUser || {});
        response["token"] = response?.data?.authToken || "";
        response["type"] = "Bearer";


        if (this.checkPermission(response)) {
          sessionStorage.setItem('PortalUserRole', JSON.stringify(this.getGrantedAuthority(response)));
          sessionStorage.setItem('accessToken', response.token);
          sessionStorage.setItem('currentUser', JSON.stringify(response.user));
          sessionStorage.setItem('portalUserInfo', JSON.stringify(response?.data?.portalUser));
          this.storage.store('encurrentUser', response.user, true)
          // console.log(this.webStorage.getItem('encurrentUser'));
          this.credentialsService.setCredentials(response, false);
          return response;
        }
        else {
          // console.log(response);
          return false;
        }
      }),
      catchError(error => {
        this.toastService.showDanger(error?.error?.message || error?.message  || 'Invalid Credentials!');
        return throwError(error);
      })
    );
  }

    register(context: RegisterContext): Observable<any> {
        return this.apiService.post_("/auth/create/user", JSON.stringify(context));
    }


  mapUserObject(source:any){
    return ({
      id: source?.id,
      surname: source?.surname || "",
      firstname: source?.firstname || "",
      // Note: source?.otherName is null in your example,
      // but the target has "SOJEH". Hardcoded or logic-based?
      otherName: source?.otherName,
      email: source?.email,
      // Strips '+' and '234' to match target format if necessary
      phoneNumber: source?.phoneNumber ? source?.phoneNumber?.replace('+234', '0') : null,
      userId: null,
      approved: source?.approved,
      departmentFk: null,
      portalUserTypeFk: {
        id: source?.portal_user_type_id,
        name: "Portal Admin", // Defaulting based on target
        description: "Portal Admin"
      },
      ministryFk: source?.ministry_id ? { id: source?.ministry_id } : null,
      agencyFk: source?.agency_id ? { id: source?.agency_id } : null,
      gender: source?.gender,
      dateOfBirth: source?.dateOfBirth,
      streetNumber: source?.streetNumber,
      postcode: source?.postcode,
      countryFk: source?.country_fk,
      nationality: source?.nationality,
      address: source?.address,
      city: source?.city,
      state: source?.state,
      lga: source?.lga,
      accreditationNumber: source?.accreditationNumber,
      pickUpLocations_fk: null,
      occupation: source?.occupation,
      isAccreditedUser: source?.isAccreditedUser,
      // Branch Location appears to be static/lookup-based in your target
      branchLocation: {
        id: 1,
        is_active: true,
        branchCode: "HQ",
        stateCode: "000",
        state_fk: {
          id: 20,
          name: "FCT",
          website: "abuja",
          code: "FCT",
          state_slogan: "Centre of Unity",
          zone_fk: null,
          countryt_fk: { id: 1, name: "NIGERIA", code: "NIGERIA" }
        },
        lga_fk: null
      },
      staffId: source?.staff_id,
      isCustomer: source?.is_customer,
      nin: source?.nin,
      identityType: source?.identity_type || "SUPPORT_USER",
      isASspecialAccessUser: source?.is_a_special_access_user,
      updatingOffice: null,
      // Values below are likely handled via a separate auth logic or default
      password: "",
      dateCreated: source?.date_created || source?.migratedAt,
      emailAddressVerified: source?.isEmailVerified,
      phoneNumberVerified: source?.isPhoneNumberVerified,
      lockedOut: null,
      lockoutDate: null,
      status: source?.status,
      secretQuestion: "crp_support",
      secretQuestionAnswer: null,
      contactAddress: null,
      addressFk: null,
      nationalityFk: null,
      username: source?.username,
      noOfTasks: 0,
      branch_location: {
        id: 1,
        is_active: true,
        branchCode: "HQ",
        stateCode: "000",
        state_fk: {
          id: 20,
          name: "FCT",
          website: "abuja",
          code: "FCT",
          state_slogan: "Centre of Unity",
          zone_fk: null,
          countryt_fk: { id: 1, name: "NIGERIA", code: "NIGERIA" }
        },
        lga_fk: null
      },
      pwd: "",
      fullNames: `${source?.firstname} ${source?.otherName || ""} ${source?.surname}`.trim()?.replace("  ", " "),
      fullAddress2: ""
    })
  };


    /**
     * Logs out the user and clear credentials.
     * @return True if the user was logged out successfully.
     */
    logout(status?:string): Observable<boolean> {
      if (this.isLoggedIn()){
        console.log('status::', status);
          this.apiService.get_("/auth/logout/"+status).pipe(finalize(()=>{
              this.credentialsService.setCredentials();
              this.credentialsService.clearStorage();
              return of(true);
          }))
          .subscribe(response =>{
              console.log("");
          });
          this.credentialsService.setCredentials();
          this.credentialsService.clearStorage();
          return of(true);
      }
      else{
          this.credentialsService.setCredentials();
          this.credentialsService.clearStorage();
          return of(true);
      }
  }
    isLoggedIn() {
        return sessionStorage.getItem('accessToken') ? true : false;
    }

    getLandingPage() {
        return "/dashboard";
    }


}
